// Soft UI Dashboard React layouts
import Dashboard from "layouts/dashboard";
//import Tables from "layouts/tables";
import Bp from "layouts/bp";
import Material from "layouts/material";
import Billing from "layouts/billing";
import BPList from "layouts/bp-list";
import VendorList from "layouts/vendor-list";
import MaterialList from "layouts/material-list";
import CustomerList from "layouts/customer-list";
import RTL from "layouts/rtl";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";

// Soft UI Dashboard React icons
import Shop from "examples/Icons/Shop";
import Office from "examples/Icons/Office";
import Settings from "examples/Icons/Settings";
import Document from "examples/Icons/Document";
import SpaceShip from "examples/Icons/SpaceShip";
import CustomerSupport from "examples/Icons/CustomerSupport";
import CreditCard from "examples/Icons/CreditCard";
import Cube from "examples/Icons/Cube";
import SMaterial from "layouts/SMaterial";
import SMaterialList from "layouts/SMaterial List";
import VendorRegister from "layouts/newVendor/vendorRegistration"
import VendorForm from "layouts/VendorForm";
import Tables from "layouts/tables3";
import VendorsList from "layouts/VendorsList";
import MaterialsList from "layouts/MaterialsList";
import Customerslist from "layouts/Customerslist";
import ApprovalMatrix from "layouts/ApprovalMatrix";
import RoleMaster from "layouts/RoleMaster";
import RoleMasterView from "layouts/RoleMasterView";
import UsersList from "layouts/UsersList";
import LoginHistory from "layouts/LoginHistory";
import Editable from "layouts/Editable";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    route: "/dashboard",
    icon: <Shop size="12px" />,
    component: <Dashboard />,
    noCollapse: true,
  },
  // {
  //   type: "collapse",
  //   name: "Vendor Creation Form",
  //   key: "vendor-form",
  //   route: "/vendor-form",
  //   icon: <Office size="12px" />,
  //   component: <Tables />,
  //   noCollapse: true,
  // },
  // {
  //   type: "collapse",
  //   name: "BP Creation Form",
  //   key: "bp-form",
  //   route: "/bp-form",
  //   icon: <Office size="12px" />,
  //   component: <Bp />,
  //   noCollapse: true,
  // },
  // {
  //   type: "collapse",
  //   name: "Vendor Form",
  //   key: "vendor-form",
  //   route: "/vendor-form",
  //   icon: <Office size="12px" />,
  //   component: <VendorForm />,
  //   noCollapse: true,
  // },
  {
    type: "collapse",
    name: "Materials List",
    key: "materials-list",
    route: "/materials-list",
    icon: <Cube size="12px" />,
    component: <MaterialsList />,
    noCollapse: true,
    permissionKey: "material_view"
  },
  {
    type: "collapse",
    name: "Material Creation",
    key: "material",
    route: "/material",
    icon: <Office size="12px" />,
    component: <SMaterial />,
    noCollapse: true,
    permissionKey: "material_create"
  },
  // {
  //   type: "collapse",
  //   name: "S Material List",
  //   key: "s-material-list",
  //   route: "/s_material_list",
  //   icon: <Office size="12px" />,
  //   component: <SMaterialList />,
  //   noCollapse: true,
  // },
  //  {
  //    type: "collapse",
  //    name: "List for Approval",
  //    key: "approver",
  //    route: "/approver",
  //    icon: <CreditCard size="12px" />,
  //    component: <Billing />,
  //    noCollapse: true,
  // },
  
  // {
  //   type: "collapse",
  //   name: "BP List",
  //   key: "bp-list",
  //   route: "/bp-list",
  //   icon: <Cube size="12px" />,
  //   component: <BPList />,
  //   noCollapse: true,
  // },
  {
    type: "collapse",
    name: "Customers List",
    key: "customers-list",
    route: "/customers-list",
    icon: <Cube size="12px" />,
    component: <Customerslist />,
    noCollapse: true,
    permissionKey: "customer_view"
  },
  // {
  //   type: "collapse",
  //   name: "Vendor List",
  //   key: "vendor-list",
  //   route: "/vendor-list",
  //   icon: <Cube size="12px" />,
  //   component: <VendorList />,
  //   noCollapse: true,
  // },
  {
    type: "collapse",
    name: "Vendors List",
    key: "vendors-list",
    route: "/vendors-list",
    icon: <Cube size="12px" />,
    component: <VendorsList />,
    noCollapse: true,
    permissionKey: "vendor_view"
  },
  
  // {
  //   type: "collapse",
  //   name: "Material List",
  //   key: "material-list",
  //   route: "/material-list",
  //   icon: <Cube size="12px" />,
  //   component: <MaterialList />,
  //   noCollapse: true,
  // },
  
  // {
  //   type: "collapse",
  //   name: "Approved Requests",
  //   key: "approved-requests",
  //   route: "/approved-requests",
  //   icon: <Settings size="12px" />,
  //   component: <RTL />,
  //   noCollapse: true,
  // },
  { type: "title", title: "Admin Section", key: "account-pages",permissionKey: "for_admin" },
  // {
  //   type: "collapse",
  //   name: "Profile",
  //   key: "profile",
  //   route: "/profile",
  //   icon: <CustomerSupport size="12px" />,
  //   component: <Profile />,
  //   noCollapse: true,
  // },
  {
    type: "collapse",
    name: "Approval Matrix",
    key: "approval-matrix",
    route: "/approval-matrix",
    icon: <CustomerSupport size="12px" />,
    component: <ApprovalMatrix />,
    noCollapse: true,
    permissionKey: "for_admin"
  },
  {
    type: "collapse",
    name: "User Master",
    key: "user-master",
    route: "/user-master",
    icon: <CustomerSupport size="12px" />,
    component: <UsersList />,
    noCollapse: true,
    permissionKey: "for_admin"
  },
  {
    type: "collapse",
    name: "User Creation",
    key: "user-creation",
    route: "/user-creation",
    icon: <CustomerSupport size="12px" />,
    component: <SignUp />,
    noCollapse: true,
    permissionKey: "for_admin"
  },
  {
    type: "collapse",
    name: "Role Master",
    key: "role-master",
    route: "/role-master",
    icon: <Cube size="12px" />,
    component: <RoleMasterView />,
    noCollapse: true,
    permissionKey: "for_admin"
  },
  {
    type: "collapse",
    name: "Role Creation",
    key: "role-creation",
    route: "/role-creation",
    icon: <Cube size="12px" />,
    component: <RoleMaster />,
    noCollapse: true,
    permissionKey: "for_admin"
  },
  {
    type: "collapse",
    name: "Field Configuration",
    key: "field-configuration",
    route: "/field-configuration",
    icon: <Cube size="12px" />,
    component: <Editable />,
    noCollapse: true,
    permissionKey: "for_admin"
  },
  {
    type: "collapse",
    name: "Login History",
    key: "login-history",
    route: "/login-history",
    icon: <Cube size="12px" />,
    component: <LoginHistory />,
    noCollapse: true,
    permissionKey: "for_admin"
  },
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    route: "/authentication/sign-in",
    icon: <Document size="12px" />,
    component: <SignIn />,
    noCollapse: true,
  },
  // {
  //   type: "collapse",
  //   name: "Vendor Register",
  //   key: "vendor-register",
  //   route: "/newVendor/vendor-register",
  //   icon: <Document size="12px" />,
  //   component: <VendorRegister />,
  //   noCollapse: true,
  // },
  // {
  //   type: "collapse",
  //   name: "User Registration",
  //   key: "sign-up",
  //   route: "/authentication/sign-up",
  //   icon: <SpaceShip size="12px" />,
  //   component: <SignUp />,
  //   noCollapse: true,
  // },
];

export default routes;
